<template>
    <div v-if="type!='button'"
        class="fav-element"
        @click.prevent="toggleFav"
        :title="title">

        <i class="fa"
            aria-hidden="true"
            :class="{'fa-heart':isFav(),'fa-heart-o':!isFav()}"></i>

    </div>

    <button v-else
        type="button"
        @click="toggleFav">
        <i class="fa"
            aria-hidden="true"
            :class="{'fa-heart':isFav(),'fa-heart-o':!isFav()}"></i>

        <span v-show="!isFav()">{{addLabel}}</span>
        <span v-show="isFav()">{{removeLabel}}</span>

    </button>



</template>

<script>
    import V from 'voUtils/V.js'

    import {
    	isFav, toggleFav, onFavUpdate, getFavIds
    }
    from 'voUtils/FavStore.js';


    export default {
    	voVueComponent: 'voffice-fav-element',
    	props: {
    		type: String,
    		unitId: Number,
    		addLabel: String,
    		removeLabel: String,
    		name: String,
    		region: String
    	},
    	computed: {
    		title: function() {
    			return this.voMsg('favorites');
    		}
    	},
    	mounted: function() {
    		onFavUpdate(() => {
    			this.$forceUpdate();
    		});

    	},
    	methods: {

    		getEtrackerProduct: function() {
    			let product = {
    				id: this.unitId,
    				name: this.name,
    				price: 0,
    				currency: 'EUR',
    				category: ['Ferienwohnung', this.region]
    			}
    			return product;
    		},

    		isFav: function() {
    			return isFav(this.unitId);
    		},
    		toggleFav: function() {
    			V.log("Fav clicked!", this.unitId);
    			var product = this.getEtrackerProduct();
    			if (isFav(this.unitId)) {
    				//console.log('removeFav:', product);
    				etCommerce.attachEvent({
    						'mousedown': ['ButtonZuMerkliste']
    					},
    					'removeToWatchlist', product, 2);
    			} else {
    				//console.log('addFav:', product);
    				etCommerce.attachEvent({
    						'mousedown': ['ButtonAusMerkliste']
    					},
    					'insertFromWatchlist', product, 3);

    			}
    			toggleFav(this.unitId);
    		}
    	}


    };
</script>